import cn from 'classnames';
import SelectPlanRadio from '../SelectPlanRadio';
import styles from './carousel.module.scss';

type SelectPlanBannerProps = {
  containerClass: string;
  billingCycle: string;
  setBillingCycle: BaseAnyFunction;
  annualSavings: string;
};
const SelectPlanBanner = ({ containerClass, billingCycle, setBillingCycle, annualSavings }: SelectPlanBannerProps) => (
  <div className={cn('paddingY-small2', styles.selectPlanBannerContainer, containerClass)}>
    <SelectPlanRadio billingCycle={billingCycle} setBillingCycle={setBillingCycle} annualSavings={annualSavings} stacked={false} />
  </div>
);

export default SelectPlanBanner;

/*
  This is the mobile version of selectplan (billing cycle) radio
  The banner sticks to the top, until the pricing table is out of view when scrolling
*/
